module.exports = __webpack_public_path__ + "img/c483198.png";